import Point from "./Point";

export class PortInfo {
  point: Point;
  dir: number | undefined;

  constructor(point: Point, dir: number | undefined) {
    this.point = point;
    this.dir = dir;
  }
}
